import React from "react";
import moment from "moment";
import {useLocation} from "react-router-dom";
import {AppBar, Box, IconButton, Drawer, ListItemText, Toolbar, Typography} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
// import NotificationsIcon from "@mui/icons-material/Notifications";
import Menus from "./Menus";
import {menuList} from "../../router/menuList";

export default function Header(props) {
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const toggleOpen = () => {
    setOpen(!open);
  };
  const menuNm = () => {
    let childrenList = menuList.map((menu) => (
      menu.children.map((child) => (
        child[1].includes(location.pathname) && child[0]
      ))
    ));
    return childrenList.filter((child) => (Boolean(child)))[0];
  };

  const convDay = () => {
    const weekday = ["日", "月", "火", "水", "木", "金", "土"]
    return moment().format("M月 D日 ") + "(" + weekday[(parseInt(moment().format("d")))] + ")"
  };

  return (
    <Box
      position = "sticky"
      sx = {{top: 0, zIndex: 99}}
    >
      <AppBar
        className = {location.pathname !== "/" ? "header" : "bgcolor-none"}
        position = "static"
      >
        <Toolbar>
          <React.Fragment>
            <IconButton
              aria-label = "menu"
              color = "default"
              disabled = {location.pathname === "/"}
              disableRipple
              edge = "start"
              id = "hamburger_btn"
              onClick = {toggleOpen}
              size = "small"
              sx = {{opacity: location.pathname === "/" ? 0 : 1}}
            >
              <MenuIcon
                fontSize = "large"
              />
            </IconButton>
            <Drawer
              anchor = "left"
              onClose = {toggleOpen}
              open = {open}
            >
              <Menus
                lgFontFg = {props.lgFontFg}
                setLgFontFg = {props.setLgFontFg}
              />
            </Drawer>
          </React.Fragment>
          <ListItemText
            secondary = {
              <React.Fragment>
                <Typography
                  color = "default.main"
                  sx = {{fontSize: "0.8rem"}}
                >
                  TODAY
                </Typography>
                <Typography
                  color = "default.main"
                  sx = {{ml: 0.2}}
                >
                  {convDay()}
                </Typography>
              </React.Fragment>
            }
            secondaryTypographyProps = {{component: "div"}}
            sx = {{mr: "auto", ml: 1, opacity: location.pathname === "/" ? 0 : 1}}
          />
          <Typography
            color = "default.main"
            sx = {{ml: "auto", mt: 1, mr: 1, opacity: location.pathname === "/" ? 0 : 1}}
          >
            {menuNm()}
          </Typography>
          {/* <IconButton
            aria-label = "menu"
            color = "default"
            disabled
            size = "small"
            sx = {{ml: 2, opacity: 0}}
          >
            <NotificationsIcon
              fontSize = "large"
            />
          </IconButton> */}
        </Toolbar>
      </AppBar>
    </Box>
  )
};
